export default __webpack_public_path__ + "static/media/b0d556d165c87450cbfdbc0927a68f53.geojson";